<template>
  <input type="radio" 
    :name="name" 
    :id="id" 
    :value="value"
    v-bind:checked="checked"
    v-on:change="updateValue({
      objectType: objectType,
      objectId  : objectId,
      key       : propertyKey,
      value     : value,
      index     : index
    })" />
</template>

<script>

  export default {

    props : {

      objectType : {
        type    : String,
        required: false
      },

      objectId : {
        type    : Number,
        required: false
      },

      name : {
        type    : String,
        required: false
      },

      id : {
        type : String,
        required : false
      },

      checked : {
        type : Boolean,
        required : false
      },

      propertyKey : {
        type    : String,
        required: false
      },

      updateValue : {
        type : Function,
        required : false
      },

      value : {
        // type    : String,
        required: false
      },

      index : {
        type    : Number,
        required: false
      },

    },

    // data() {
    //   return {
    //     localValue : this.value
    //   }
    // },

    methods : {
      localUpdateValue(value) {
        if(this.index != null && this.objectType != null) {
          this.updateValue(this.objectType, this.index, this.propertyKey, value)
        }

        else if(this.index == null && this.objectType != null) {
          this.updateValue(this.objectType, this.propertyKey, value) 
        }

        else if(this.index == null && this.objectType == null) {
          this.updateValue(this.propertyKey, value)
        }
      }
    }
  }
</script>